module.exports = __webpack_public_path__ + "static/media/img-bottom-actions.cf910348.png";